var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserOctagon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3492 10.725V19.275C26.3492 20.675 25.5992 21.9751 24.3867 22.6876L16.9617 26.975C15.7492 27.675 14.2492 27.675 13.0242 26.975L5.59922 22.6876C4.38672 21.9876 3.63672 20.6875 3.63672 19.275V10.725C3.63672 9.32504 4.38672 8.02499 5.59922 7.31249L13.0242 3.025C14.2367 2.325 15.7367 2.325 16.9617 3.025L24.3867 7.31249C25.5992 8.02499 26.3492 9.31254 26.3492 10.725Z",
    stroke: "#191A23",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.0023 13.75C16.6109 13.75 17.9148 12.446 17.9148 10.8375C17.9148 9.22896 16.6109 7.92505 15.0023 7.92505C13.3938 7.92505 12.0898 9.22896 12.0898 10.8375C12.0898 12.446 13.3938 13.75 15.0023 13.75Z",
    stroke: "#191A23",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 20.8249C20 18.5749 17.7625 16.75 15 16.75C12.2375 16.75 10 18.5749 10 20.8249",
    stroke: "#191A23",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOctagon);
export default __webpack_public_path__ + "static/media/user-octagon.fda4de954b9068b5768a3b82f449c4a4.svg";
export { ForwardRef as ReactComponent };